"use strict";
let initialized: boolean = false;
let tagID: string;

// Add 'dataLayer' to global window object
declare global {
  interface Window {
    dataLayer: any[];
    gtag?: Gtag.Gtag;
  }
}

interface PageParams {
  /** The page's title. */
  page_title?: string;
  /** The page's URL. */
  page_location?: string;
  /** The path portion of location. This value must start with a slash (/) character. */
  page_path?: string;
}

type EventParams = Gtag.ControlParams | Gtag.EventParams | Gtag.CustomParams;
// interface EventParams {
//   value?: number;
//   currency?: string;
//   items?: string;
//   coupon?: string;
//   checkout_step?: string;
//   checkout_option?: string;
//   method?: string;
// }

/**
 * Global site tag (gtag.js) - Google Analytics
 * @param {string} trackingID The Google analytics tracking id
 */
export function embed(trackingID: string): Gtag.Gtag {
  if (initialized) {
    throw "Error, cannot embed gtagjs twice";
  }
  initialized = true;
  tagID = trackingID;
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingID}`;
  script.async = true;
  if (document.body) {
    document.body.appendChild(script);
  } else {
    document.head.appendChild(script);
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());

  return window.gtag;
}

/**
 *
 * @param config Tracks a pageview for the gtag embedded on the page.
 * @param trackingID (optional) The tracking ID. By default, uses the value from calling embed() so this shouldn't normally be set.
 */
export function trackPage(config?: PageParams, trackingID?: string) {
  if (!window.gtag) {
    throw "Must embed the gtag library before calling trackPage";
  }
  window.gtag("config", tagID, config);
}

export function trackEvent(eventName: string, config?: EventParams) {
  if (!window.gtag) {
    throw "Must embed the gtag library before calling trackEvent";
  }
  window.gtag("event", eventName, config);
}
